import { render, staticRenderFns } from "./print-table-wuliao.vue?vue&type=template&id=bb04b0e6&scoped=true"
import script from "./print-table-wuliao.vue?vue&type=script&lang=js"
export * from "./print-table-wuliao.vue?vue&type=script&lang=js"
import style0 from "./print-table-wuliao.vue?vue&type=style&index=0&id=bb04b0e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb04b0e6",
  null
  
)

export default component.exports